import { memo } from 'react'

export const MixerFooter = memo(function MixerFooter() {
  return (
    <div className="flex items-center justify-end px-3.5 py-2 border-t border-border bg-surface-1 shrink-0">
      <div className="flex items-center gap-2.5 text-[10px] text-text-muted/50">
        <span><kbd className="font-mono text-[10px] px-1 py-0.5 rounded bg-surface-2 border border-border text-text-secondary">Space</kbd> play/pause</span>
        <span><kbd className="font-mono text-[10px] px-1 py-0.5 rounded bg-surface-2 border border-border text-text-secondary">M</kbd> mute</span>
        <span><kbd className="font-mono text-[10px] px-1 py-0.5 rounded bg-surface-2 border border-border text-text-secondary">S</kbd> solo</span>
        <span><kbd className="font-mono text-[10px] px-1 py-0.5 rounded bg-surface-2 border border-border text-text-secondary">⌘Z</kbd> undo</span>
        <span><kbd className="font-mono text-[10px] px-1 py-0.5 rounded bg-surface-2 border border-border text-text-secondary">2×click</kbd> play clip</span>
      </div>
    </div>
  )
})
